// extracted by mini-css-extract-plugin
export default {"info":"MmLOLv","time":"YkhiXV","title":"JYPgIG","ellipsis":"dL6YHe","more":"SQKs0k"};